import dark from './dark'
import light from './light'
import { Theme, ThemeSelector } from './types'

const useTheme = (theme?: ThemeSelector): Theme => {
  return theme === 'dark' ? dark : light
}

export default useTheme
